<div class="recruitment-app">
  <aside class="recruitment-sidebar" [class.mobile-open]="mobileNavigationOpen">
    <div class="brand-row">
      <a class="brand" routerLink="/recruitment" queryParamsHandling="preserve" (click)="closeMobileNavigation()">
        <span class="brand-mark">K</span>
        <span>Konvac</span>
      </a>
      <button class="sidebar-close" type="button" aria-label="Close navigation" (click)="closeMobileNavigation()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="workspace-label">Recruitment workspace</div>

    <nav class="sidebar-navigation" aria-label="Recruitment navigation">
      <a *ngIf="isAdmin" routerLink="/admin-dashboard" (click)="closeMobileNavigation()">
        <mat-icon>admin_panel_settings</mat-icon>
        Admin console
      </a>
      <a routerLink="/recruitment" queryParamsHandling="preserve" [routerLinkActiveOptions]="{ exact: true }" routerLinkActive="active" (click)="closeMobileNavigation()">
        <mat-icon>space_dashboard</mat-icon>
        Overview
      </a>
      <a routerLink="/recruitment/benchmarks" queryParamsHandling="preserve" routerLinkActive="active" (click)="closeMobileNavigation()">
        <mat-icon>work_outline</mat-icon>
        Role benchmarks
      </a>
      <a routerLink="/recruitment/candidates" queryParamsHandling="preserve" routerLinkActive="active" (click)="closeMobileNavigation()">
        <mat-icon>groups</mat-icon>
        Talent pool
      </a>
    </nav>

    <div class="sidebar-spacer"></div>

    <div class="sidebar-help">
      <mat-icon>verified_user</mat-icon>
      <div>
        <strong>Private workspace</strong>
        <span>Candidate decisions are only visible to your organization.</span>
      </div>
    </div>
  </aside>

  <button
    *ngIf="mobileNavigationOpen"
    class="mobile-backdrop"
    type="button"
    aria-label="Close navigation"
    (click)="closeMobileNavigation()">
  </button>

  <div class="recruitment-main">
    <header class="recruitment-topbar">
      <button class="menu-button" type="button" aria-label="Open navigation" (click)="mobileNavigationOpen = true">
        <mat-icon>menu</mat-icon>
      </button>
      <div class="topbar-title">
        <span class="eyebrow">Recruitment</span>
        <strong>Candidate intelligence</strong>
      </div>
      <div class="topbar-user">
        <span class="user-avatar">{{ recruiterEmail.charAt(0).toUpperCase() }}</span>
        <div class="user-copy">
          <strong>{{ recruiterEmail }}</strong>
          <span>{{ isAdmin ? 'Konvac admin' : 'Recruiter' }}</span>
        </div>
        <button class="sign-out" type="button" matTooltip="Sign out" (click)="signOut()">
          <mat-icon>logout</mat-icon>
        </button>
      </div>
    </header>

    <main class="recruitment-content">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
